/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Err_Pick_GradeInputs */

const vi_form_err_pick_grade = /** @type {(inputs: Form_Err_Pick_GradeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn phân loại`)
};

/**

* @param {Form_Err_Pick_GradeInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const form_err_pick_grade = /** @type {((inputs?: Form_Err_Pick_GradeInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Err_Pick_GradeInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_form_err_pick_grade(inputs)
});